import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { replaceNode } from "./Utils";

export default class LoadSeoSidebarText {
  static onLoadNavSidebarText(data: DresonRuleResolvedEvent): void {
    const navSidebarTextNode: HTMLElement | null =
      document.getElementById("reptile-sidebar-text") || document.getElementById("san_navSidebarText");
    if (!navSidebarTextNode) {
      return;
    }

    const { rule } = navSidebarTextNode.dataset;
    if (rule === data.rule) {
      return;
    }

    fetch(LoadSeoSidebarText.uri(data.rule))
      .then(LoadSeoSidebarText.extractResponseText)
      .then((html: string) => LoadSeoSidebarText.replaceNavSidebarText(navSidebarTextNode, data.rule, html))
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadSeoSidebarText.uri(data.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200 && xhr.status !== 204) {
      throw Error(`Failed to retrieve nav sidebar: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  /**
 *
 *
 *
 *
 */
  private static replaceNavSidebarText(navSidebarTextNode: HTMLElement, nodeRule: string, newHtml: string) {
    replaceNode(navSidebarTextNode, nodeRule, newHtml);
  }

  private static uri(ruleString: string) {
    return `/scp-bob/page/${encodeURIComponent(ruleString)}/sidebar.html`;
  }
}
